import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';

export const catalogItemsSortOrders = [
    SearchSortAndDirection.LotNumberLowest,
    // SEAR-704: Elastic on catalog pages experiment
    SearchSortAndDirection.MostRelevant,
    SearchSortAndDirection.MostBids,
    SearchSortAndDirection.PriceHighest,
    SearchSortAndDirection.PriceLowest,
    SearchSortAndDirection.EstimateHighest,
    SearchSortAndDirection.HammerPriceHighest,
    SearchSortAndDirection.Promoted,
] as const;
